export default class ThemeSwitch {
  constructor(element) {
    this.$el = $(element)
    this.$triggerBtn = this.$el.find('.theme-switch__btn')
    // this.$copyContent = this.$el.find('code')
    // this.$answerBtn = this.$el.find('[data-answer-btn]')
    // this.$innerContent = this.$el.find('.topic-card__inner')
    // this.$answerForm = this.$el.find('.topic-card__answer-form')
    // this.collapsedClass = 'collapsed'
    this.init();
  }
  init() {
    const {$triggerBtn} = this

    $triggerBtn.on('click', function (e) {
      const currentColor = $('html').attr('data-theme')
      const newColor = currentColor === 'dark' ? 'light' : 'dark'
      document.cookie = `theme=${newColor}; max-age=2592000; path=/`
      $('html').attr('data-theme', newColor)
    })
  }
}
